export default {
      id: "avatar-usage",
      viewBox: "0 0 52 52",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#avatar",
      toString: function () {
        return this.url;
      }
    }